import Seo from '../../components/Seo/Seo';
import styles from './PrivacyPage.module.css';

export default function PrivacyPage() {
	return (
		<>
			<Seo
				title="Adatvédelmi tájékoztató - Akku 24+"
				description="Az Akku 24+ adatvédelmi tájékoztatója: milyen személyes adatokat kezelünk, milyen célból, és milyen jogok illetik meg Önt."
			/>

			<div className={styles.page}>
				<div className={styles.container}>
					<h1 className={styles.heading}>Adatvédelmi tájékoztató</h1>
					<p className={styles.effectiveDate}>Hatályos: 2026. június 11-től visszavonásig</p>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>1. Az adatkezelő</h2>
						<div className={styles.textContent}>
							<p>
								<strong>TIPCOOP Gyártó, Szolgáltató és Kereskedő Kft.</strong>
								<br />
								Székhely: 1027 Budapest, Margit körút 64/B.
								<br />
								Telephely: 1132 Budapest, Váci út 8.
								<br />
								Adószám: 10365324-2-41
								<br />
								Cégjegyzékszám: 01 09 067412
								<br />
								Ügyfélszolgálat: +36-30-626-6000
							</p>
							<p>
								Jelen tájékoztató az akku-24.hu weboldal (a továbbiakban: Weboldal) használata, valamint
								a Weboldalon leadott megrendelések során megvalósuló adatkezelésekre vonatkozik. Az
								adatkezelő elkötelezett a személyes adatok védelme iránt, és azokat az Európai Parlament
								és a Tanács (EU) 2016/679 rendelete (GDPR), valamint az információs önrendelkezési jogról
								és az információszabadságról szóló 2011. évi CXII. törvény (Infotv.) rendelkezéseinek
								megfelelően kezeli.
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>2. A kezelt adatok köre</h2>
						<div className={styles.textContent}>
							<p>A Weboldalon leadott megrendelés során az alábbi személyes adatokat kérjük el:</p>
							<ul>
								<li>név,</li>
								<li>telefonszám,</li>
								<li>e-mail cím,</li>
								<li>szállítási cím (irányítószám, város, utca és házszám),</li>
								<li>eltérő számlázási cím esetén a számlázási adatok,</li>
								<li>a megrendelt termékre és a kért kiszállási időpontra vonatkozó adatok.</li>
							</ul>
							<p>
								A Weboldal böngészése regisztrációhoz és személyes adatok megadásához nem kötött. A
								kosár tartalmát és a kiválasztott jármű adatait a böngésző helyi tárolója (local
								storage) őrzi meg az Ön eszközén – ezek az adatok nem kerülnek továbbításra, és bármikor
								törölhetők a böngésző adatainak törlésével. A Weboldal marketing- vagy követési célú
								sütiket (cookie) nem használ.
							</p>
							<p>
								A látogatások méréséhez egy saját, 6 hónapig érvényes analitikai sütit (asos_vid) használunk, amely véletlenszerű azonosítót tartalmaz, személyes adatot nem. Ez segít megkülönböztetni az új és a visszatérő látogatókat, és nem kerül továbbításra harmadik félnek.
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>3. Az adatkezelés célja és jogalapja</h2>
						<div className={styles.textContent}>
							<ul>
								<li>
									<strong>A megrendelés teljesítése</strong> – a kiszállítás megszervezése, az
									időpont-egyeztetés és a kapcsolattartás. Jogalap: a szerződés teljesítése (GDPR 6.
									cikk (1) bekezdés b) pont).
								</li>
								<li>
									<strong>Számlázás</strong> – a számviteli bizonylatok kiállítása és megőrzése.
									Jogalap: jogi kötelezettség teljesítése (GDPR 6. cikk (1) bekezdés c) pont, a
									számvitelről szóló 2000. évi C. törvény).
								</li>
								<li>
									<strong>Garanciális ügyintézés</strong> – a jótállási igények kezelése. Jogalap: jogi
									kötelezettség teljesítése, illetve a szerződés teljesítése.
								</li>
							</ul>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>4. Az adatok megőrzésének ideje</h2>
						<div className={styles.textContent}>
							<ul>
								<li>
									A számviteli bizonylatokat (számla és az annak alátámasztásául szolgáló adatok) a
									számviteli törvény alapján 8 évig őrizzük meg.
								</li>
								<li>
									A garanciális ügyintézéshez kapcsolódó adatokat a jótállási idő lejártáig, illetve az
									abból eredő igények elévüléséig kezeljük.
								</li>
								<li>
									Az egyéb, megrendeléshez kapcsolódó adatokat a megrendelés teljesítését követően, az
									igények elévülési idejének (5 év) elteltével töröljük.
								</li>
							</ul>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>5. Az adatokhoz való hozzáférés és adattovábbítás</h2>
						<div className={styles.textContent}>
							<p>
								A személyes adatokhoz kizárólag az adatkezelő azon munkatársai férnek hozzá, akiknek ez a
								feladataik ellátásához szükséges (ügyfélszolgálat, kiszállítást és beszerelést végző
								szerelők, számlázás). Az adatokat harmadik fél részére marketing célból nem adjuk át, és
								nem továbbítjuk harmadik országba.
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>6. Az Önt megillető jogok</h2>
						<div className={styles.textContent}>
							<p>A GDPR alapján Ön jogosult:</p>
							<ul>
								<li>tájékoztatást kérni személyes adatai kezeléséről (hozzáférési jog),</li>
								<li>pontatlan adatainak helyesbítését kérni,</li>
								<li>adatainak törlését kérni (a kötelező adatkezelések kivételével),</li>
								<li>az adatkezelés korlátozását kérni,</li>
								<li>tiltakozni az adatkezelés ellen,</li>
								<li>adatainak hordozható formátumban történő kiadását kérni.</li>
							</ul>
							<p>
								Kérelmét az ügyfélszolgálati elérhetőségeken nyújthatja be; arra legkésőbb 30 napon belül
								válaszolunk.
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>7. Jogorvoslati lehetőségek</h2>
						<div className={styles.textContent}>
							<p>
								Amennyiben megítélése szerint személyes adatainak kezelése sérti a vonatkozó
								jogszabályokat, panaszával a Nemzeti Adatvédelmi és Információszabadság Hatósághoz
								(NAIH) fordulhat:
							</p>
							<p>
								<strong>Nemzeti Adatvédelmi és Információszabadság Hatóság</strong>
								<br />
								Cím: 1055 Budapest, Falk Miksa utca 9-11.
								<br />
								Levelezési cím: 1363 Budapest, Pf. 9.
								<br />
								E-mail: ugyfelszolgalat@naih.hu
								<br />
								Honlap: www.naih.hu
							</p>
							<p>Emellett jogainak megsértése esetén bírósághoz is fordulhat.</p>
						</div>
					</section>
				</div>
			</div>
		</>
	);
}
